<template>
  <ul class="sidebar navbar-nav">
      <li class="nav-item" :class="{ active: index == 1}">
        <router-link class="nav-link" to="/account">
          <i class="fas fa-user"></i>
          <span>Người dùng</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ active: index == 2}">
        <router-link class="nav-link" to="/user_group">
          <i class="fas fa-users"></i>
          <span>Nhóm</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ active: index == 3}">
        <router-link class="nav-link" to="/permission">
          <i class="fas fa-user-shield"></i>
          <span>Quyền</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ active: index == 4}">
        <router-link class="nav-link" to="/picklist">
          <i class="fas fa-tasks"></i>
          <span>Danh mục</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ active: index == 5}">
        <router-link class="nav-link" to="/bank">
          <i class="fas fa-university"></i>
          <span>Ngân hàng</span>
        </router-link>
      </li>
      <li class="nav-item" :class="{ active: index == 6}">
        <router-link class="nav-link" to="/value">
          <i class="fas fa-database"></i>
          <span>Data</span>
        </router-link>
      </li>
    </ul>
</template>

<script>
export default {
  name: "NhanSuSideBar",
  props: ['index'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
